import Vue from 'vue'
import Vuex from 'vuex'
import _ from 'underscore'


Vue.use(Vuex);

var themes = {
	white: {
		name: 'black',
		class: "stwhite",
		color: "#ffffff",
		media: '(prefers-color-scheme: light)',
		rootid: ''
	},

	black: {
		name: 'white',
		class: "stblack",
		color: "#1e2235",
		media: '(prefers-color-scheme: dark)',
		rootid: 'black'
	}
}

var mex = {
	theme: function (state, value) {

		if (themes[value]) {
			state.theme = value

			if (document.documentElement.hasAttribute('theme')) {
				document.documentElement.removeAttribute('theme');
			}

			document.documentElement.setAttribute('theme', themes[value].rootid);

			var root = document.querySelector(':root');

			var rootStyles = getComputedStyle(root);

			state.currentStyles = rootStyles

			localStorage.setItem('theme', state.theme)

		}
	}
}

var storeFactory = function (vxstorage) {


	var state = {
		testsettings: false,
		icon: null,
		loading: false,
		online: true,
		theme: 'white',
		themes: themes,
		globalpreloader: false,
		allnotifications: 0,
		gallery: null,
		optimizationOnScreen : null,
		share: null,
		menu: null,
		redirect: '',
		auth: -1,
		lastlogin: '',
		userinfo: {},

		tscrolly: 0,
		tscrollx: 0,
		dscrolly: 0,
		dscrollx: 0,

		theight: 0,
		twidth: 0,
		dheight: 0,
		dwidth: 0,

		currentStyles: {},
		modals: [],

		selection: null,

		camera: null,
		photolibraryaccessdecline: false,
		fx: null,

		notifications: [],


		features : {},

		uploading : [],
		mobileview : false,

		age : 4,
		locale : 'en',
		leftmenuOpened : false,
		appinfo : {},

		chats : {},
		playingstory : null,
		delayedAction : null,
		playlist : null,

		muted : false,
		noimagesinstory : false,
		buttonsblock : false,
		tempage : undefined,
		lssettings : {},
		update : null,
		updating : null,
		cdvproducts : [],
		successCDVpayment : false
	}



	var getters = {
		currentStyleValue: (state) => (id) => {
			return state.currentStyles.getPropertyValue(id)
		},

		currentColorValue: (state, store) => (id) => {
			return (store.currentStyleValue(id) || "").split(', ')
		},

		colorByValue: (state, store) => (value) => {

			var st = '--neutral-grad-0'

			if (value < 0) st = '--color-bad'

			if (value > 0) st = '--color-good'

			return 'rgb(' + store.currentStyleValue(st) + ')'
		}
	}

	var mutations = {
		
		setTestsettings(state, boo){
			state.testsettings = boo;
		},

		clearall(state) {

			state.icon = null
			state.loading = false
			state.online = true
			state.unauthorized = false

			state.globalpreloader = false
			state.allnotifications = 0

			state.gallery = null
			state.menu = null
			state.redirect = ''
			state.auth = -1
			state.notifications = []
		},

		photolibraryaccessdecline: function (state, value) {
			state.photolibraryaccessdecline = value
		},

		tscrolly(state, value) {
			state.tscrolly = value;
		},
		tscrollx(state, value) {
			state.tscrollx = value;
		},
		dscrolly(state, value) {
			state.dscrolly = value;
		},
		dscrollx(state, value) {
			state.dscrollx = value;
		},

		theight(state, value) {
			state.theight = value;
		},

		twidth(state, value) {
			state.twidth = value;
			state.mobileview = state.twidth <= 768 ? true : false
		},

		dheight(state, value) {
			state.dheight = value;
		},

		dwidth(state, value) {
			state.dwidth = value;
		},

		redirect(state, value) {
			state.redirect = value;
		},

		update(state, value) {
			state.update = value;
		},
		updating(state, value) {
			state.updating = value;
		},

		uploading(state, value = []) {
			state.uploading = state.uploading.concat(value);
		},

		clearUploading(state, value) {
			state.uploading = [];
		},

		globalpreloader: function (state, value) {
			state.globalpreloader = value
		},

		icon(state, value) {
			state.icon = value
		},

		auth(state, value) {
			state.auth = value
		},

		appinfo(state, v) {
			state.appinfo = v;
		},

		userinfo(state, v) {
			state.userinfo = v;
		},

		lssettings(state, v){

			var mapped = {}

			_.each(v.data, (v, i) => {
				mapped[i] = v.value
			})

			Vue.set(state.lssettings, v.type, mapped)

		},

		leftmenuOpened(state, v) {
			state.leftmenuOpened = v ? true : false;
		},

		tempage(state, v) {
			state.tempage = v || undefined;
		},

		chat(state, {id, chats}) {

			Vue.set(state.chats, id, [...chats])
		},

		chats(state, v) {
			state.chats = {...v};
		},

		initmodals(state){
			try{
				var modals = JSON.parse(localStorage['savedModals'] || '[]')

				_.each(modals, (modal) => {
					this.commit('OPEN_MODAL', modal)
				})
			}
			catch(e){

			}
		},

		init(state) {
			mex.theme(state, localStorage.getItem('theme') || 'white')

			state.lastlogin = localStorage.getItem('lastlogin')

			state.theight = state.dheight = window.innerHeight
			state.twidth = state.dwidth = window.innerWidth

		},

		successCDVpayment(state, v){
			state.successCDVpayment = v || null
		},

		noimagesinstory(state, v){
			state.noimagesinstory = v || null
		},
		muted(state, v){
			state.muted = v || null
		},

		buttonsblock(state, v){
			state.buttonsblock = v || null
		},
		
		playingstory(state, v){

			console.log('commit', v)

			state.playingstory = v || null

			this._vm.core.cordovakit.playingStoryBackground(state.playingstory ? true : false)

			//galleryBackground
		},

		delayedAction(state, v){

			if (state.delayedAction){

				clearTimeout(state.delayedAction.timeout)
				state.delayedAction = null
				
			}

			if(!v){
				return
			}

			if(!v.action) throw 'emptyaction'
			if(!v.text) return 'emptytext'
			if(!v.time || v.time < 0) return 'emptytime'

			state.delayedAction = {...v}

			state.delayedAction.timeout = setTimeout(() => {

				if (state.delayedAction.action){
					state.delayedAction.action()
				}
				
				state.delayedAction = null

			}, v.time)

			return () => {
				if (state.delayedAction){
					clearTimeout(state.delayedAction.timeout)
					state.delayedAction = null
				}
			}

			
		},

		playlist(state, v){

			var prevstate = {}

			if (state.playlist){
				prevstate = state.playlist.prevstate || {}
			}
			else{
				prevstate = {
					buttonsblock : state.buttonsblock,
					muted : state.muted,
					noimagesinstory : state.noimagesinstory
				}
			}

			if(!v && state.playlist){
				var s = state.playlist.prevstate

				this.commit('buttonsblock', s.buttonsblock || false)
				this.commit('muted', s.muted || false)
				this.commit('noimagesinstory', s.noimagesinstory || false)
			}

			if (v && v.settings){
				this.commit('buttonsblock', v.settings.buttonsblock || false)
				this.commit('muted', v.settings.muted || false)
				this.commit('noimagesinstory', v.settings.noimagesinstory || false)
			}

			if (v){
				v.prevstate = prevstate
			}

			state.playlist = v || null
		},


		features(state, v){
			state.features = v
		},

		lastlogin(state, v) {
			state.lastlogin = v;

			localStorage.setItem('lastlogin', v)
		},

		GALLERY(state, v) {
			state.gallery = v || null
		},

		FX(state, v) {
			state.fx = v || null
		},


		SHARE(state, v) {
			state.share = v || null
		},

		theme(state, value) {
			mex.theme(state, value)
		},

		locale(state, value) {
			state.locale = value
		},

		SET_MENU(state, v) {
			state.menu = v
		},

		OPEN_CAMERA(state, v) {
			state.camera = v
		},

		CLOSE_CAMERA(state) {
			state.camera = null
		},

		PIP_MODAL(state, {id, value}){
			var index = -1 
			var modal = _.find(state.modals, (m, i) => {
				if(m.id == id){
					index = i
					return true
				}
			})

			if (modal){
				modal.pip = value
				Vue.set(state.modals, index, modal)
			}

			this.commit('OVF_HA')
		},

		OVF_HA(state){

			var mdls = _.filter(state.modals, (modal) => {
				return !modal.pip
			})

			var h = document.getElementById('html');

			console.log('mdls.length', mdls.length)

			if (mdls.length) {
				h.style.overflow = 'hidden'
			}
			else{
				h.style.overflow = null
			}

			var saved = _.filter(state.modals, (m) => {
				return m.save
			})

			localStorage['savedModals'] = JSON.stringify(saved)
		},

		CHANGE_MODAL_DATA(state, {id, data}) {

			var index = -1 
			var modal = _.find(state.modals, (m, i) => {
				if (m.id == id){
					index = i
					return true
				}
			})

			if (modal){
				modal.data = data || {}
				Vue.set(state.modals, index, modal)

				return true
			}

			return false
			
		},

		OPEN_MODAL(state, modal) {

			if(modal.one){
				var last = _.find(state.modals, (m) => {
					return m.id == modal.id
				})

				if (last){
					this.commit('CLOSE_MODAL', modal.id)

					setTimeout(() => {
						state.modals.push(modal);

						this.commit('OVF_HA')
					}, 100)

					return
				}
			}

			state.modals.push(modal);

			console.log("HERE")

			this.commit('OVF_HA')
		},

		CLOSE_MODAL(state, id) {
			state.modals = _.filter(state.modals, function (m) {
				return m.id != id
			})

			this.commit('OVF_HA')
		},

		optimizationOnScreen(state, d){
			state.optimizationOnScreen = d
		},

		cdvproducts(state, d){
			state.cdvproducts = d || []
		},

		select(state, {

			context = 'general',
			items = {}

		}) {


			if (!state.selection || state.selection.context != context) {

				state.selection = {
					context: context,
					items: {}
				}

			}

			_.each(items, (item) => {
				Vue.set(state.selection.items, item.ID || item.id, item)
			})


		},

		unselect(state, {
			context = 'general',
			items = null
		}) {

			if (!state.selection || state.selection.context != context || !items) {
				state.selection = null
			}

			if (state.selection && items) {
				_.each(items, (item) => {
					Vue.delete(state.selection.items, item.ID || item.id)
				})

				if (_.isEmpty(state.selection.items)) {
					state.selection = null
				}
			}

		},

		removeNotifications(state){
			state.notifications = []
		},

		removeNotification(state, notification){
			state.notifications = _.filter(state.notifications, (n) => {
				return (n.id || n.eventid) != (notification.id || notification.eventid)
			})
		},

		addNotification(state, notification){
			state.notifications.unshift(notification)
		}

	}

	var actions = {

		OPEN_MODAL({ commit }, { modal }) {



			if (!index) index = 0

			if (!images) images = []

			if (images.length) {

				commit('GALLERY', {
					images: images,
					index: index
				})

			} else {
				commit('GALLERY', null)
			}

		},

		SHOW_GALLERY({ commit }, { images, index }) {

			if (!index) index = 0

			if (!images) images = []

			if (images.length) {

				commit('GALLERY', {
					images: images,
					index: index
				})

			} else {
				commit('GALLERY', null)
			}

		},
	}

	if (vxstorage) {
		_.each(vxstorage.storage, function (storage) {
			state['_' + storage.type] = {}

			mutations['_set_' + storage.type] = function (state, obj) {

				Vue.set(state['_' + storage.type], obj[storage.index], obj)
			}

			mutations['_delete_' + storage.type] = function () {
				state['_' + storage.type] = {}
			}

			mutations['_invalidate_' + storage.type] = function (state, index) {

				Vue.delete(state['_' + storage.type], index)


			}
		})
	}

	return new Vuex.Store({
		state,
		getters,
		mutations,
		actions
	})
}

export default storeFactory;